import { render, staticRenderFns } from "./ThinningTemplate.vue?vue&type=template&id=2c06052b"
import script from "./ThinningTemplate.vue?vue&type=script&lang=js"
export * from "./ThinningTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports